import React, { useEffect, useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "./Breadcrumb";
import { API_URL } from "..";
import { useParams } from "react-router-dom";
import { Button, Spinner } from "react-bootstrap";
import swal from "sweetalert";

const ViewDriverPage = () => {
    const {id} = useParams();
    const [password, setPassword]= useState({
        new_password:'',
        current_password:'',
      })
      const [saveChangeLoader, setSaveChangesLoader] = useState(false)
    const [formValues,setFormValues] = useState({
        name : '',
        email:'',
        password:'',
        phone:'',
        driving_license:'',
        expire_date_driving_license:'',
        driving_license_class:'',
        goverment_id:'',
        hire_date:'',
        job_title:'',
        employment_type:'',
        truck_id:'',
        salary_amount:'',
        payout_type:'',
        details:{
            work_phone:'',
            home_phone:'',
            address:'',
            city:'',
            state:'',
            zipcode:'',
            date_of_birth:'',
            medical_date:'',
            emergency_contact_name:'',
            emergency_contact_phone:'',
            notes:''
        },
        truck:null
      })
      const fetchSingleDriver = async ()=>{
        try {
                const api = await fetch(API_URL+'/api/driver/fetch-single/'+ id , {method : 'GET'});
                const response = await api.json();
                if(api.status === 200){
                  setFormValues(response.driver)
                  if(response.driver.details.medical_date){

                    setFormValues((prev)=>({
                      ...prev, 
                      details:{
                        ...prev.details,
                        medical_date : response.driver.details.medical_date.split('T')[0]
                      }
                    }))
                  }
                  if(response.driver.details.date_of_birth){
                    setFormValues((prev)=>({
                      ...prev, 
                      details:{
                        ...prev.details,
                        date_of_birth : response.driver.details.date_of_birth.split('T')[0]
                      }
                    }))
                  }
                  
                }
        } catch (error) {
            
        }
      }
      useEffect(()=>{
        fetchSingleDriver()
        fetchTrucks();
      },[1])
      const [truckData, setTruckData] = useState([]);
      const fetchTrucks = async () => {
        const value = JSON.parse(localStorage.getItem("user"));
        const apiCall = await fetch(`${API_URL}/api/truck/${value.id}`, {
          method: "GET",
        });
        const response = await apiCall.json();
        if (apiCall.status === 200) {
          
          const filter = response.truck.map((e) => ({
            label: e.name,
            value: e.id,
          }));
          setTruckData(filter);
        }
      };

      
      const updateDriverData = async (event)=>{
           event.preventDefault(); 
           setSaveChangesLoader(true)
           const formData = new FormData();
            
            formData.append('name' , formValues.name)
            formData.append('email' , formValues.email)
            formData.append('phone' , formValues.phone)
            formData.append('driving_license' , formValues.driving_license)
            formData.append('expire_date_driving_license' , formValues.expire_date_driving_license)
            formData.append('driving_license_class' , formValues.driving_license_class)
            formData.append('goverment_id' , formValues.goverment_id)
            formData.append('hire_date' , formValues.hire_date)
            formData.append('job_title' , formValues.job_title)
            formData.append('employement_type' , formValues.employement_type)
            formData.append('affiliate_company_id' , formValues.affiliate_company_id)
            formData.append('truck_id' , formValues.truck_id)
            formData.append('work_phone' , formValues.details?.work_phone || null)
            formData.append('salary_amount' , formValues.salary_amount || null)
            formData.append('payout_type' , formValues.payout_type || null)
            formData.append('home_phone' , formValues.details?.home_phone ||  null)
            formData.append('address' , formValues.details?.address || null)
            formData.append('city' , formValues.details?.city || null)
            formData.append('state' , formValues.details?.state || null)
            formData.append('zipcode' , formValues.details?.zipcode || null)
            formData.append('date_of_birth' , formValues.details?.date_of_birth || null)
            formData.append('medical_date' , formValues.details?.medical_date || null)
            formData.append('emergency_contact_name' , formValues.details?.emergency_contact_name || null)
            formData.append('emergency_contact_phone' , formValues.details?.emergency_contact_phone || null)
            formData.append('notes' , formValues.details?.notes || null)
            const inputMedical = document.getElementById('medical_examination').files[0];
            const check_clearance = document.getElementById('check_clearance').files[0];
            const drug_result = document.getElementById('drug_result').files[0];
            const training_certifications = document.getElementById('training_certifications').files[0];
            console.log(inputMedical)
            if (inputMedical !== undefined) {
                formData.append(
                  "medical_examination",
                  inputMedical
                );
              }
              if (check_clearance !== undefined) {
                formData.append("check_clearance", check_clearance);
              }
              if (drug_result !== undefined) {
                formData.append("drug_result", drug_result);
              }
              if (training_certifications !== undefined) {
                formData.append(
                  "training_certifications",
                  training_certifications
                );
              }
              for (const [key, value] of formData.entries()) {
                console.log(`${key}: ${value}`);
            }
            // return  false;
              try {
                const response = await fetch(API_URL + "/api/driver/update-info/"+ id, {
                  method: "PUT",
                  body: formData,
                });
          
                if (!response.ok) {
                  throw new Error("Failed to submit form");
                }
                const result = await response.json();
                
                setSaveChangesLoader(false)
                console.log("Success:", result);
                if(response.status === 200){
                  swal("Information Updated", "Driver information is successfully updated." , "success");
                  fetchSingleDriver();

                }
                
              } catch (error) {
                setSaveChangesLoader(false)
                console.error("Error:", error);
              }

      }
      
      
     
  return (
    <>
      <MasterLayout>
        <Breadcrumb title={"View Driver"} />
       
        <div className="col-xxl-12">
            
          <div className="card p-0 overflow-hidden position-relative radius-12 h-100">
          <div className=" text-end m-2" style={{
            
        }}>
        <div >
            {
                saveChangeLoader === true ?
                <Spinner/>:
            <Button type="submit" onClick={updateDriverData}>Save Changes</Button>
            }
            <button type="button" onClick={()=>alert('assssaa')} className="btn btn-danger" style={{marginLeft: 10 }}>Delete Driver</button>
        </div>
        </div>
        <form>
            <div className="card-body p-24 pt-10">
              <ul
                className="nav bordered-tab border border-top-0 border-start-0 border-end-0 d-inline-flex nav-pills mb-16"
                id="pills-tab"
                role="tablist"
              >
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link px-16 py-10 active"
                    id="pills-home-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-home"
                    type="button"
                    role="tab"
                    aria-controls="pills-home"
                    aria-selected="true"
                  >
                    Driver Info
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link px-16 py-10"
                    id="pills-details-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-details"
                    type="button"
                    role="tab"
                    aria-controls="pills-details"
                    aria-selected="false"
                  >
                    Extra Details
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link px-16 py-10"
                    id="pills-payroll-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-payroll"
                    type="button"
                    role="tab"
                    aria-controls="pills-payroll"
                    aria-selected="false"
                  >
                    
                    Payroll Information
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link px-16 py-10"
                    id="pills-license-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-license"
                    type="button"
                    role="tab"
                    aria-controls="pills-license"
                    aria-selected="false"
                  >
                    License Info
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link px-16 py-10"
                    id="pills-profile-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-profile"
                    type="button"
                    role="tab"
                    aria-controls="pills-profile"
                    aria-selected="false"
                  >
                    Documents
                  </button>
                </li>
             
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link px-16 py-10"
                    id="pills-settings-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-settings"
                    type="button"
                    role="tab"
                    aria-controls="pills-settings"
                    aria-selected="false"
                  >
                    Notes
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link px-16 py-10"
                    id="pills-password-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-password"
                    type="button"
                    role="tab"
                    aria-controls="pills-password"
                    aria-selected="false"
                  >
                    Settings
                  </button>
                </li>
              </ul>
             

             
              <div className="tab-content" id="pills-tabContent">
                <div
                  className="tab-pane fade show active"
                  id="pills-home"
                  role="tabpanel"
                  aria-labelledby="pills-home-tab"
                  tabIndex={0}
                >
                  <div className="row">
                    <div className="col-md-8">
                      <h6 className="text-lg mb-8 mt-3">Driver Information</h6>
                      <div className="row">
                        <div className="col-md-8">
                          <label htmlFor="fullname">Full Name</label>
                          <input
                            type="text"
                            id="fullname"
                            className="form-control"
                            value={formValues.name}
                            onChange={(e)=>setFormValues((prev)=>({...prev , name: e.target.value}))}
                          />
                        </div>
                      </div>
                      <div className="row mt-3">
                        <div className="col-md-6">
                          <label htmlFor="email">Email</label>
                          <input
                            type="text"
                            value={formValues.email}
                            onChange={(e)=>setFormValues((prev)=>({...prev , email: e.target.value}))}
                            id="email"
                            className="form-control"
                          />
                        </div>

                        <div className="col-md-6">
                          <label htmlFor="phone">Phone</label>
                          <input
                            type="text"
                            id="phone"
                            value={formValues.phone}
                            onChange={(e)=>setFormValues((prev)=>({...prev , phone: e.target.value}))}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="row mt-3">
                        <div className="col-md-6">
                          <label htmlFor="assigned" >Assigned Vehicle</label>
                          <select
                           value={formValues.truck_id}
                           onChange={(e)=>setFormValues((prev)=>({...prev , truck_id: e.target.value}))}
                            className="form-control"
                            id="assigned"
                          >     
                                    <option value={null}>--SELECT TRUCK--</option>
                                    {truckData.map((e)=>(<option value={e.value}>{e.label}</option>))}
                          </select>
                        </div>
                       
                      </div>
                      <div className="row mt-3">
                        <div className="col-md-8">
                          <label htmlFor="government_id">
                            Government ID (e.g., Passport, Social Security
                            Number)
                          </label>
                          <input
                           value={formValues.goverment_id}
                           onChange={(e)=>setFormValues((prev)=>({...prev , goverment_id: e.target.value}))}
                            type="text"
                            id="government_id"
                            className="form-control"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="tab-pane fade"
                  id="pills-details"
                  role="tabpanel"
                  aria-labelledby="pills-details-tab"
                  tabIndex={0}
                >
                  <div>
                    <div className="row">
                      <div className="col-md-8">
                        <h6 className="text-lg mb-8 mt-3">Extra Information</h6>

                        <div className="row mt-3">
                          <div className="col-md-6">
                            <label htmlFor="work_phone">Work Phone</label>
                            <input
                              type="text"
                              id="work_phone"
                              value={formValues.details?.work_phone}
                              onChange={(e) => 
                                setFormValues((prev) => ({
                                  ...prev,
                                  details: {
                                    ...prev.details,  // Preserve existing details
                                    work_phone: e.target.value, // Update only work_phone
                                  },
                                }))
                              }
                              className="form-control"
                            />
                          </div>

                          <div className="col-md-6">
                            <label htmlFor="home_phone">Home Phone</label>
                            <input
                              type="text"
                              id="home_phone"
                              value={formValues.details?.home_phone}
                              onChange={(e) => 
                                setFormValues((prev) => ({
                                  ...prev,
                                  details: {
                                    ...prev.details,  // Preserve existing details
                                    home_phone: e.target.value, // Update only work_phone
                                  },
                                }))
                              }
                              className="form-control"
                            />
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className="col-md-12">
                            <label htmlFor="address">Address</label>
                            <input
                              type="text"
                              value={formValues.details?.address}
                              onChange={(e) => 
                                setFormValues((prev) => ({
                                  ...prev,
                                  details: {
                                    ...prev.details,  // Preserve existing details
                                    address: e.target.value, // Update only work_phone
                                  },
                                }))
                              }
                              id="address"
                              className="form-control"
                            />
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className="col-md-4">
                            <label htmlFor="city">City</label>
                            <input
                              type="text"
                              id="city"
                              value={formValues.details?.city}
                              onChange={(e) => 
                                setFormValues((prev) => ({
                                  ...prev,
                                  details: {
                                    ...prev.details,  // Preserve existing details
                                    city: e.target.value, // Update only work_phone
                                  },
                                }))
                              }
                              className="form-control"
                            />
                          </div>
                          <div className="col-md-4">
                            <label htmlFor="state">State</label>
                            <input
                              type="text"
                              id="state"
                              value={formValues.details?.state}
                              onChange={(e) => 
                                setFormValues((prev) => ({
                                  ...prev,
                                  details: {
                                    ...prev.details,  // Preserve existing details
                                    state: e.target.value, // Update only work_phone
                                  },
                                }))
                              }
                              className="form-control"
                            />
                          </div>

                          <div className="col-md-4">
                            <label htmlFor="zipcode">Zip Code</label>
                            <input
                              type="text"
                              id="zipcode"
                              value={formValues.details?.zipcode}
                              onChange={(e) => 
                                setFormValues((prev) => ({
                                  ...prev,
                                  details: {
                                    ...prev.details,  // Preserve existing details
                                    zipcode: e.target.value, // Update only work_phone
                                  },
                                }))
                              }
                              className="form-control"
                            />
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className="col-md-6">
                            <label htmlFor="dob">Date of birth</label>
                            <input
                              type="date"
                              id="dob"
                              value={formValues.details?.date_of_birth}
                              onChange={(e) => 
                                setFormValues((prev) => ({
                                  ...prev,
                                  details: {
                                    ...prev.details,  // Preserve existing details
                                    date_of_birth: e.target.value, // Update only work_phone
                                  },
                                }))
                              }
                              className="form-control"
                            />
                          </div>

                          <div className="col-md-6">
                            <label htmlFor="medical_exam_expire_date">
                              Medical Exam Expire Date
                            </label>
                            <input
                              type="date"
                              value={formValues.details?.medical_date}
                              onChange={(e) => 
                                setFormValues((prev) => ({
                                  ...prev,
                                  details: {
                                    ...prev.details,  // Preserve existing details
                                    medical_date: e.target.value, // Update only work_phone
                                  },
                                }))
                              }
                              id="medical_exam_expire_date"
                              className="form-control"
                            />
                          </div>
                          <div className="col-md-6 mt-3">
                            <label htmlFor="emergency_contact_name">
                              Emergency Contact Name
                            </label>
                            <input
                              type="text"
                              value={formValues.details?.emergency_contact_name}
                              onChange={(e) => 
                                setFormValues((prev) => ({
                                  ...prev,
                                  details: {
                                    ...prev.details,  // Preserve existing details
                                    emergency_contact_name: e.target.value, // Update only work_phone
                                  },
                                }))
                              }
                              id="emergency_contact_name"
                              className="form-control"
                            />
                          </div>
                          <div className="col-md-6 mt-3">
                            <label htmlFor="emergency_contact_phone">
                            Emergency Contact Phone
                            </label>
                            <input
                              type="text"
                              value={formValues.details?.emergency_contact_phone}
                              onChange={(e) => 
                                setFormValues((prev) => ({
                                  ...prev,
                                  details: {
                                    ...prev.details,  // Preserve existing details
                                    emergency_contact_phone: e.target.value, // Update only work_phone
                                  },
                                }))
                              }
                              id="emergency_contact_phone"
                              className="form-control"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="tab-pane fade"
                  id="pills-payroll"
                  role="tabpanel"
                  aria-labelledby="pills-payroll-tab"
                  tabIndex={0}
                >
                  <div>
                    <div className="row">
                      <div className="col-md-8">
                        <h6 className="text-lg mb-8 mt-3">Payroll Information</h6>

                        <div className="row mt-3">
                          <div className="col-md-12">
                          <div className="mb-20">
                        <label
                          htmlFor="name"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                        Payout Mode <span className="text-danger-600">*</span>
                        </label>
                        
                        <div className="form-check checked-info d-flex align-items-center gap-2">
                         
                        {/* </div>
                        <div className="form-check checked-secondary d-flex align-items-center gap-2"> */}
                            <input
                                className="form-check-input"
                                type="radio"
                                name="payout_mode"
                                value={'hourly'}
                                checked={formValues.payout_type == 'hourly' ? true : false}
                                onChange={(e)=>setFormValues((prev)=>({...prev, payout_type: e.target.value}))}
                                id="radio"
                            />
                            <label
                                className="form-check-label line-height-1 fw-medium text-secondary-light"
                                htmlFor="radio"
                            >
                                {" "}
                                Hourly{" "}
                            </label>
                            <input
                                className="form-check-input"
                                type="radio"
                                name="payout_mode"
                                id="radio2"
                                checked={formValues.payout_type == 'weekly' ? true : false}
                                onChange={(e)=>setFormValues((prev)=>({...prev, payout_type: e.target.value}))}
                                value={'weekly'}
                            />
                            <label
                                className="form-check-label line-height-1 fw-medium text-secondary-light"
                                htmlFor="radio2"
                            >
                                {" "}
                                Weekly{" "}
                            </label>
                            <input
                                className="form-check-input"
                                type="radio"
                                name="payout_mode"
                                id="radio1"
                                checked={formValues.payout_type == 'monthly' ? true : false}
                                onChange={(e)=>setFormValues((prev)=>({...prev, payout_type: e.target.value}))}
                                value={'monthly'}
                            />
                            <label
                                className="form-check-label line-height-1 fw-medium text-secondary-light"
                                htmlFor="radio1"
                            >
                                {" "}
                               Monthly{" "}
                            </label>
                        </div>
                        </div>
                          </div>
                          <div className="col-md-6">
                            <label htmlFor="home_phone">Salary Amount</label>
                            <input
                              type="text"
                              id="salary_amount"
                              value={formValues?.salary_amount}
                              onChange={(e) => 
                                setFormValues((prev) => ({
                                  ...prev,
                                  salary_amount: e.target.value
                                }))
                              }
                              className="form-control"
                            />
                          </div>
                          <div className="col-md-6">
                            <label htmlFor="work_phone">Hire Date</label>
                            <input
                              type="date"
                              id="hire_date"
                              value={formValues?.hire_date}
                              onChange={(e) => 
                                setFormValues((prev) => ({
                                  ...prev,
                                  hire_date: e.target.value
                                }))
                              }
                             
                              className="form-control"
                            />
                          </div>

                        
                        </div>
                       
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="tab-pane fade"
                  id="pills-profile"
                  role="tabpanel"
                  aria-labelledby="pills-profile-tab"
                  tabIndex={0}
                >
                  <div>
                    <h6 className="text-lg mb-8 mt-3">Documents</h6>
                     <div className="row">
                        <div className="col-md-8">
                        <div className="mb-20">
                            <label
                              htmlFor="medical_examination"
                              className="form-label fw-semibold text-primary-light text-sm mb-8"
                            >
                              Medical Examination Certificate
                              <span className="text-danger-600">*</span>
                              {
                                formValues?.medical_examination !== null ?

                                <a className="text-primary" target="_blank" rel={'norefer'} href={API_URL+'/'+formValues?.medical_examination}>{'View'}</a> : null
                              }
                            </label>
                            <input
                              type="file"
                              name="medical_examination"
                              id="medical_examination"
                              className="form-control radius-8"
                            />
                          </div>
                          <div className="mb-20">
                            <label
                              htmlFor="check_clearance"
                              className="form-label fw-semibold text-primary-light text-sm mb-8"
                            >
                              Background Check Clearance
                              <span className="text-danger-600">*</span>
                              {
                                formValues?.check_clearance !== null ?

                                <a className="text-primary" target="_blank" rel={'norefer'} href={API_URL+'/'+formValues?.check_clearance}>{'View'}</a> : null
                              }
                            </label>
                            <input
                              type="file"
                              name="check_clearance"
                              id="check_clearance"
                              className="form-control radius-8"
                            />
                          </div>
                          <div className="mb-20">
                            <label
                              htmlFor="drug_result"
                              className="form-label fw-semibold text-primary-light text-sm mb-8"
                            >
                              Drug Test Results
                              <span className="text-danger-600">*</span>
                              {
                                formValues?.drug_result !== null ?

                                <a className="text-primary" target="_blank" rel={'norefer'} href={API_URL+'/'+formValues?.drug_result}>{'View'}</a> : null
                              }
                            </label>
                            <input
                              type="file"
                              name="drug_result"
                              id="drug_result"
                              className="form-control radius-8"
                            />
                          </div>
                          <div className="mb-20">
                            <label
                              htmlFor="training_certifications"
                              className="form-label fw-semibold text-primary-light text-sm mb-8"
                            >
                              Training Certifications
                              <span className="text-danger-600">*</span>
                              {
                                formValues?.training_certifications !== null ?

                                <a className="text-primary" target="_blank" rel={'norefer'} href={API_URL+'/'+formValues?.training_certifications}>{'View'}</a> : null
                              }
                            </label>
                            <input
                              type="file"
                              name="training_certifications"
                              id="training_certifications"
                              className="form-control radius-8"
                            />
                          </div>
                        </div>
                     </div>
                  </div>
                </div>
                <div
                  className="tab-pane fade"
                  id="pills-password"
                  role="tabpanel"
                  aria-labelledby="pills-password-tab"
                  tabIndex={0}
                >
                  <div className="row">
                    <div className="col-md-8">
                      <h6 className="text-lg mb-8 mt-3">Change Password</h6>
                      <div className="row">
                        <div className="col-md-6">
                          <label htmlFor="fullname">Current Password</label>
                          <input
                            type="text"
                            id="fullname"
                            value={password.current_password}
                            onChange={(e)=>setPassword((prev)=>({...prev, current_password: e.target.value}))}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="row mt-3">
                        <div className="col-md-6">
                          <label htmlFor="fullname">New Password</label>
                          <input
                            type="text"
                            id="fullname"
                            value={password.new_password}
                            onChange={(e)=>setPassword((prev)=>({...prev, new_password: e.target.value}))}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="row mt-3">
                        <div className="col-md-6">
                         <button type="button"
                          onClick={async ()=>{
                                if(password.current_password === ""){
                                    alert('Current password is required');
                                    return false;
                                }
                                else if(password.new_password === ""){
                                    alert('New password is required');
                                    return false;
                                }
                                else{
                                    const api = await fetch(API_URL+ '/api/driver/update-password/'+id ,{method : 'POST' , body : JSON.stringify(password) , headers:{'Content-Type': 'application/json'}} );
                                    const response = await api.json();
                                    if(api.status === 200){
                                        alert('Password is changed');
                                        setPassword({
                                            new_password :'',
                                            current_password: '',
                                        })
                                    }
                                    else{
                                        alert(response.message);
                                        
                                    }
                                }
                          }}    
                         className="btn btn-success">Change Password</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="tab-pane fade"
                  id="pills-settings"
                  role="tabpanel"
                  aria-labelledby="pills-settings-tab"
                  tabIndex={0}
                >
                  <div>
                    <h6 className="text-lg mb-8 mt-3">Notes</h6>
                     <div className="row">
                        <div className="col-md-8">
                           <textarea rows={6}
                            value={formValues.details?.notes}
                            onChange={(e) => 
                              setFormValues((prev) => ({
                                ...prev,
                                details: {
                                  ...prev.details,  // Preserve existing details
                                  notes: e.target.value, // Update only work_phone
                                },
                              }))
                            }
                           className="form-control" ></textarea>
                        </div>
                     </div>
                  </div>
                </div>
                <div
                  className="tab-pane fade"
                  id="pills-license"
                  role="tabpanel"
                  aria-labelledby="pills-license-tab"
                  tabIndex={0}
                >
                  <div>
                    <h6 className="text-lg mb-8 mt-3">License Information</h6>
                     <div className="row">
                        <div className="col-md-8">
                        <div className="row">
                        <div className="col-md-8">
                           <label htmlFor="driving_license">Driver’s License Number</label>
                           <input 
                           id="driving_license"
                           value={formValues.driving_license}
                           onChange={(e)=>setFormValues((prev)=>({...prev , driving_license: e.target.value}))}
                           type="text"
                            className="form-control"/>
                        </div>
                        <div className="col-md-6 mt-3">
                           <label htmlFor="license_expire_date">License Expiry Date</label>
                           <input
                           id="license_expire_date"
                           value={formValues.expire_date_driving_license}
                           onChange={(e)=>setFormValues((prev)=>({...prev , expire_date_driving_license: e.target.value}))}
                           type="date" className="form-control"/>
                        </div>
                        <div className="col-md-6 mt-3">
                           <label htmlFor="license_class">License Class/Type (CDL, Non-CDL)</label>
                           <input
                           id="license_class"
                           value={formValues.driving_license_class}
                           onChange={(e)=>setFormValues((prev)=>({...prev , driving_license_class: e.target.value}))}
                           type="text" className="form-control"/>
                        </div>
                     </div>
                        </div>
                     </div>
                  </div>
                </div>
              </div>
           
            </div>
            </form>
          </div>
        </div>
      </MasterLayout>
    </>
  );
};

export default ViewDriverPage;
